import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getServiceBookingScreenTitle,
  renderServiceBookingScreen,
} from "../../components/serviceBooking/ServiceBookingScreens";
import { setPageSeo } from "../../utils/seo";
import "./ServiceBookingPage.css";

const ServiceBookingPage = () => {
  const { screen = "home" } = useParams();
  const activeScreen = screen || "home";

  useEffect(() => {
    setPageSeo({
      title: `${getServiceBookingScreenTitle(activeScreen)} | Service Booking`,
      description: "Separate service booking screens for laundry-style segment group flow.",
      path: `/service-booking/${activeScreen}`,
    });
  }, [activeScreen]);

  return (
    <div className="service-booking-page">
      <div className="service-booking-stage">
        <div className="service-booking-device">
          {renderServiceBookingScreen(activeScreen)}
        </div>
      </div>
    </div>
  );
};

export default ServiceBookingPage;
